// extracted by mini-css-extract-plugin
export default {"wpp":"wppBtn_wpp__PE81J"};